export const downloadBulkTenderDocumentsArchive = (
	archive: ArrayBuffer,
	fileName = "bulk-tender-documents.zip",
): void => {
	const blob = new Blob([archive], { type: "application/zip" });
	const url = URL.createObjectURL(blob);
	const link = globalThis.document.createElement("a");
	link.href = url;
	link.download = fileName;
	globalThis.document.body.append(link);
	link.click();
	link.remove();
	setTimeout(() => URL.revokeObjectURL(url), 1000);
};
